import { Typography, Link } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function Copyright() {
    const { t } = useTranslation();

    return (
      <Typography variant="body2" color="text.secondary" align="center">
        Copyright © { new Date().getFullYear() } 
        &nbsp;
        <Link href="https://www.conta.com.py" target="_blank">
          Conta
        </Link>{' '}
        <br />
        { t('footer.tagline') }
      </Typography>
    );
  }
